export default "__VITE_ASSET__CKyIGQ2X__"